import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// current User Details
export const GetRemoteControl = createAsyncThunk(
  "remotecontrol/getRemoteControl",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/remote-control/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during server type data.";
      return rejectWithValue(errorMessage);
    }
  }
);

// save a new user
export const saveRemoteControl = createAsyncThunk(
  "remotecontrol/saveRemoteControl",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/remote-control/new`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during adding remote-control.";
      return rejectWithValue(errorMessage);
    }
  }
);

// get all the users --admin
export const getAllRemoteControl = createAsyncThunk(
  "remotecontrol/getAllRemoteControl",
  async (data, { rejectWithValue }) => {
    try {

      console.log('getting data from remotecontrol')

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/remote-control/all`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
        // {
        //   headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3NDQ3MjRiZWRjYjU5YjQ2NzMxM2FhYyIsInJlZnJlc2hUb2tlbiI6ImMyYTI1OThhOWE1MDUxMjAiLCJpYXQiOjE3MzI2MjcxMzYsImV4cCI6MTczMjcxMzUzNn0.--cyDg0YrNo75GztH0edknspRD40Cn9fCUVkbqcn4EM` },
        // }
      );

       console.log('getting data of remote-control ', response?.data)
      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data?.result;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "getting error during  save data of remote-control.";
      return rejectWithValue(errorMessage);
    }
  }
);

// update a user  --admin
export const updateRemoteControl = createAsyncThunk(
  "remotecontrol/updateRemoteControl",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/remote-control/admin/${data.id}`,
        data.data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during update remote-control.";
      return rejectWithValue(errorMessage);
    }
  }
);




// block a user  --admin
export const blockRemoteControl = createAsyncThunk(
  "remotecontrol/blockRemoteControl",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/remote-control/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during delete remote-control.";
      return rejectWithValue(errorMessage);
    }
  }
);



